import { Grid, Typography, CircularProgress, Box } from "@mui/material";
import ValuoTable from "../ValuoTable";
import { useState, useEffect } from "react";

const DashboardProfessionista = ({
  user,
  evaluations,
  loadAppData,
  apiErrorModal,
}) => {
  const currentYear = new Date().getFullYear();

  const currentYearEvaluations = evaluations
    ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .slice(0, 1);

  const currentPhase = currentYearEvaluations[0]?.phase;

  const getPhaseMessage = (phase) => {
    switch (phase) {
      case "0":
        return "Entra nella valutazione annuale, compila i campi richiesti e invia al partner la tua autovalutazione.";
      case "1":
        return "Hai inserito la tua autovalutazione annuale. Attendi che il partner inserisca la sua valutazione. Riceverai un'email quando avrà terminato.";
      case "2":
        return "Il partner ha inserito la sua valutazione e fisserà a stretto giro una riunione con te per discutere il risultato e concordare gli obiettivi per il prossimo anno. Dopo la riunione, il processo di valutazione annuale verrà concluso dal partner.";
      default:
        return "";
    }
  };

  return (
    <Grid
      item
      xs={11}
      md={9}
      justifyContent="center"
      alignItems="flex-start"
      sx={{ width: "100%", paddingY: "40px" }}
    >
      {user?.role === "collaborator" &&
      currentYearEvaluations.length > 0 &&
      !apiErrorModal &&
      currentPhase <= 2 ? (
        <Grid
          item
          xs={12}
          sx={{
            backgroundColor: "#fae63436",
            padding: "20px",
            color: "#1b2838",
            height: "fit-content",
            marginBottom: "30px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            <div
              className="icon-info"
              style={{
                marginRight: "10px",
                flexShrink: 0,
                marginTop: "1px",
              }}
            />
            <Box>
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#1b2838",
                  mb: 0.5,
                }}
              >
                Processo di valutazione in corso
              </Typography>
              <Typography>{getPhaseMessage(currentPhase)}</Typography>
            </Box>
          </Box>
        </Grid>
      ) : user?.role === "collaborator" &&
        currentYearEvaluations.length === 0 &&
        !apiErrorModal ? (
        <Grid
          item
          xs={12}
          sx={{
            backgroundColor: "#fae63436",
            // borderLeft: "6px solid #fae634",
            padding: "20px",
            color: "#1b2838",
            height: "fit-content",
            marginBottom: "30px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            <div
              className="icon-info"
              style={{
                marginRight: "10px",
                flexShrink: 0,
                marginTop: "1px",
              }}
            />
            <Box>
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#1b2838",
                  mb: 0.5,
                }}
              >
                Nessun processo di valutazione in corso
              </Typography>
              <Typography>
                Il processo di valutazione viene attivato una volta l'anno dal
                partner di riferimento. Non appena verrà attivato riceverai
                un'email.
              </Typography>
            </Box>
          </Box>
        </Grid>
      ) : (
        <Typography sx={{ mb: 5, fontSize: 22, fontWeight: 600 }}>
          Lista valutazioni
        </Typography>
      )}

      {/* TABELLA */}
      {evaluations.length > 0 && (
        <ValuoTable
          user={user}
          evaluations={evaluations}
          loadAppData={loadAppData}
        />
      )}
    </Grid>
  );
};

export default DashboardProfessionista;
